import { FC } from 'react';
import { Text, Button } from '@livechat/design-system-react-components';

import { useGetMe } from 'hooks/use-get-me';
import { useProducts } from 'hooks/use-products';
import { OrganizationGraphQLResponse } from 'hooks/use-organizations';
import { getAppLinkByName, getProductDisplayName } from 'helpers/product';
import { pushExternalRedirectToDataLayer } from 'helpers/tracking';
import { removeItem } from 'helpers/storage/local-storage';
import { formatArray } from 'helpers/account';

import * as styles from './styles';

type Props = {
  organizationsWithProduct: OrganizationGraphQLResponse[];
  productToActivate: string;
  switchToDefaultChooser: () => void;
};

export const ProductInOtherOrganization: FC<Props> = ({
  organizationsWithProduct,
  productToActivate,
  switchToDefaultChooser,
}) => {
  const { roles } = useGetMe();
  const { getRedirectUrl, isFetchingProducts } = useProducts();

  const handleChooserSwitch = () => {
    switchToDefaultChooser();
  };

  const organizationsNames = formatArray(
    organizationsWithProduct.map((organization) => organization.name)
  );

  const productName = getProductDisplayName(productToActivate);
  const hasRoleInPP = roles?.some((role) => role.product === 'PartnerProgram');

  const handleLogin = () => {
    pushExternalRedirectToDataLayer(getAppLinkByName(productToActivate));
    removeItem('signup');
  };

  if (isFetchingProducts) {
    return null;
  }

  if (productToActivate === 'PartnerProgram' && !hasRoleInPP) {
    return null;
  }

  if (productToActivate === 'PartnerProgram' && !hasRoleInPP) {
    return null;
  }

  return (
    <div css={styles.container}>
      {organizationsWithProduct.length > 1 ? (
        <div>
          <Text css={styles.text}>
            You already use {productName} in other organizations: {organizationsNames}
          </Text>
          <Button kind="link-light" onClick={handleChooserSwitch}>
            Log in to {productName}
          </Button>
        </div>
      ) : (
        <div>
          <Text css={styles.text}>
            You already use {productName} in other organization: {organizationsWithProduct[0].name}
          </Text>
          <Button
            href={getRedirectUrl(productToActivate, organizationsWithProduct[0].organization_id)}
            kind="link-light"
            onClick={handleLogin}
          >
            Log in to {productName}
          </Button>
        </div>
      )}
    </div>
  );
};
